import type { Component, Entity2D } from '../../odie';

import { CountBlockOptionDef, StatueBlockProps } from '../defs/block';
import { StatueBlockView } from '../views/blocks/StatueBlockView';

// types
//-----------------------------------------------------------------------------
export type StatueBlockComponentOptions = {
  props: StatueBlockProps;
  option?: number;
};

/*
    statue block component
*/
export class StatueBlockComponent implements Component {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockStatue';

  // fields
  //-------------------------------------------------------------------------
  // injected
  public entity!: Entity2D;
  // scene
  public view!: StatueBlockView;

  // properties
  //-------------------------------------------------------------------------
  private props!: StatueBlockProps;
  // count
  public get count(): number {
    return this.view.count;
  }

  public set count(value: number) {
    // update view
    this.view.count = value;
  }

  // impl
  //-------------------------------------------------------------------------
  public init(options: StatueBlockComponentOptions): void {
    // get option def
    const optionDef = options.props.options?.[
      options.option || 0
    ] as CountBlockOptionDef;

    this.props = options.props;

    // create view
    this.view = new StatueBlockView(options.props);

    // set initial count
    this.count = optionDef.count;

    // Set the getGameplayState retrieval function
    this.entity.c.block.getGameplayState = () => this.getGameplayState();
  }

  public getGameplayState(): number {
    const options = this.props.options as CountBlockOptionDef[];
    return options.findIndex((opt) => {
      return opt.count === this.view.count;
    });
  }
}
